import { NoteContext } from '@src/notes/domain/NoteContext';
import {
  MultipleValuesField,
  OptionalBooleanField,
  StringField,
} from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class NoteContextField extends MultipleValuesField {
  public static fieldName = 'noteContext' as const;
  public static options = Object.values(NoteContext);
  public static validator = yup.array().min(1, 'isRequired').required();
}

export class NoteContentField extends StringField {
  public static fieldName = 'noteContent' as const;
  public static validator = yup
    .string()
    .trim()
    .required('noteContentIsRequired');
}

export class SendNoteByMailField extends OptionalBooleanField {
  public static fieldName = 'sendNoteByMail' as const;
}
